module.exports = __webpack_public_path__ + "img/starthouse_bodyimage04.720b1b0e.jpg";